import { SET_CURRENT_PAGINATION_NUMBER as t } from "./types.js";
function n(r) {
  return {
    type: t,
    payload: r
  };
}
export {
  n as setCurrentPaginationNumber
};
//# sourceMappingURL=actions.js.map
